module.exports = __webpack_public_path__ + "static/Alegreya-Regular-53b8a5b98c14d506d383d0c783e51b64.woff";